import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-triangle-right",
  templateUrl: "./med-icon-triangle-right.component.html",
})
export class MedIconTriangleRightComponent extends SvgMixinComponent {}
